import React from "react";
import { Link } from "react-router-dom";
import { Feather, ThermometerSnowflake, Ban, Microscope, FileCheck, Lock, ArrowRight } from "lucide-react";

const BADGES = [
  { icon: Feather, label: "Gentle By Design" },
  { icon: ThermometerSnowflake, label: "No Direct Heat" },
  { icon: Ban, label: "No Harsh Chemicals" },
  { icon: Microscope, label: "Individual Evaluation" },
  { icon: FileCheck, label: "Documented Handling" },
  { icon: Lock, label: "Confidential Service" },
];

export const TrustBadges = ({ compact = false }) => {
  return (
    <div data-testid="trust-badges" className={`border-y border-[color:var(--line)] bg-[#0b0b0e] ${compact ? "" : "noise"}`}>
      <div className="mx-auto max-w-[1200px] px-5 py-6">
        <div className="flex items-center justify-between gap-4 mb-4">
          <p className="eyebrow">Gentle By Design</p>
          <Link
            to="/trust-center"
            data-testid="trust-badges-link"
            className="inline-flex items-center gap-1.5 text-[11px] font-tech tracking-widest text-[color:var(--chrome-3)] hover:text-[color:var(--cyan)] transition-colors"
          >
            TRUST CENTER <ArrowRight size={13} />
          </Link>
        </div>
        <div className="grid grid-cols-3 sm:grid-cols-6 gap-3">
          {BADGES.map((b) => (
            <div key={b.label} className="flex flex-col items-center text-center gap-2">
              <div className="w-10 h-10 rounded-xl holo-border flex items-center justify-center">
                <b.icon size={17} className="text-[color:var(--cyan)]" />
              </div>
              <span className="font-tech text-[10px] leading-tight tracking-wide text-[color:var(--chrome-2)]">
                {b.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
